<header>
  <div class="time">
    <div class="date-group">
      <time class="date"
        >{{ date() | date : "EEEE" | titlecase }}
        {{ date() | date : "d. MMMM" }}</time
      >
      <ng-content select="[dateExtra]" />
    </div>
    <div class="clock-group">
      <time class="clock"> {{ date() | date : "HH:mm" }}</time>
      <ng-content select="[clockBelow]" />
    </div>
  </div>

  @if(spinnerState() === 'loading'){
  <mat-spinner class="loading-spinner" diameter="20"></mat-spinner>
  }

  <mat-progress-bar
    mode="determinate"
    [value]="progressValue()"
  ></mat-progress-bar>
</header>
